import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { StyledLabel } from './TextField.style';
import { isSmallTextFieldSizes } from '../../utils/input';
import { useTheme } from '../ThemeProvider/useTheme';
export const TextFieldLabel = ({ disabled, hasError, hasValue, id, isFocused, label, labelOption, size, }) => {
    const { colors } = useTheme();
    const color = useMemo(() => {
        if (hasError) {
            return colors.content.critical;
        }
        if (isFocused) {
            return colors.content.subdued;
        }
        if (disabled) {
            return colors.content.disabled;
        }
        return colors.content.placeholder;
    }, [colors, disabled, hasError, isFocused]);
    const small = isSmallTextFieldSizes(size);
    const isShrink = isFocused || hasValue || (labelOption === 'sticky' && !small);
    return (_jsx(StyledLabel, { variant: "body", htmlFor: id, component: "label", weight: isShrink ? 'medium' : 'normal', color: color, "$isShrink": isShrink, "$isHidden": isShrink && (labelOption === 'nonshrink' || small), "$size": size, children: label }));
};
